export default __webpack_public_path__ + "static/media/bg-tunnels-377x189.935432c2.svg";